import React from 'react'
import {useNavigate} from 'react-router-dom'
import FinanceLayout from './FinanceLayout'
import CardImg from './assets/credit-card.jpg'
import LoanImg from './assets/loan.jpg'
import InsImg from './assets/ins.jpg'

const products = [
  {
    title: 'Business Card',
    detail: '3 curated offers',
    description:
      'Compare business credit cards that reward your business spending with cashback, points, travel rewards and more.',
    features: [
      'Compare rewards and card features',
      'See fees clearly before you apply',
      'Apply in a few steps',
    ],
    path: '/finance/business-card',
    buttonText: 'Discover Offers',
    image: CardImg,
    accentClass: 'bg-light-primary',
    badgeClass: 'badge-light-primary',
  },
  {
    title: 'Business Loan',
    detail: 'Multiple lenders',
    description: 'Compare loan options from multiple lenders and estimate your monthly payments. ',
    features: [
      'See live estimates of payments',
      'Compare lenders and terms',
      "Apply when you're ready",
    ],
    path: '/finance/business-loan',
    buttonText: 'Discover Offers',
    image: LoanImg,
    accentClass: 'bg-light-success',
    badgeClass: 'badge-light-success',
  },
  {
    title: 'Business Insurance',
    detail: '4 provider',
    description: 'Compare coverage options to find the right protection for your business.',
    features: [
      'Compare providers and coverage',
      'Explore different policy types',
      'Review options before applying',
    ],
    path: '/finance/insurance',
    buttonText: 'Discover Offers',
    image: InsImg,
    accentClass: 'bg-light-warning',
    badgeClass: 'badge-light-warning',
  },
]

const FinancePage: React.FC = () => {
  const navigate = useNavigate()

  return (
    <>
      <div className=''>
        <h3 className='text-dark fw-bolder mb-2'>Finance</h3>
        <p className='fs-6 mb-0'>Compare business cards, loans, and insurance options</p>
      </div>
      <div className='row g-6 mt-2'>
        {products.map((product) => (
          <div key={product.title} className='col-12 col-xl-4'>
            <div className='card h-100 border border-gray-200 shadow-sm p-0 rounded-top-1'>
              <div className='rounded-top-1'>
                <img
                  src={product.image}
                  alt={product.title}
                  className='w-100 rounded-top-3'
                  style={{
                    height: '300px',
                    objectFit: 'cover',
                  }}
                />
              </div>
              <div className='card-body p-7 d-flex flex-column'>
                <div className='d-flex flex-column align-items-center text-center gap-4 mb-6'>
                  <div>
                    <h3 className='fw-bolder mb-2 fs-1'>{product.title}</h3>
                  </div>
                </div>

                <p className='fw-semibold fs-4 flex-grow-1 mb-6 text-secondary '>
                  {product.description}
                </p>

                <div className='mb-7'>
                  {product.features.map((feature) => (
                    <div key={feature} className='d-flex align-items-center'>
                      <span className='bullet bullet-dot bg-primary me-3'></span>
                      <span className='fw-semibold fs-5'>{feature}</span>
                    </div>
                  ))}
                </div>

                <div className='d-flex pt-5'>
                  <button className='btn btn-primary w-20' onClick={() => navigate(product.path)}>
                    {product.buttonText}
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  )
}

export default FinancePage
